import React from 'react';
import { motion } from 'framer-motion';

export default function Home2() {
    // Style for background image
    const bgStyle = {
        backgroundImage: "url('/Images/Aboutimg.svg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    };

    return (
        <section id="about" className="pt-24">
            <motion.div
                style={bgStyle}
                className="relative w-full bg-cover bg-center flex items-center justify-center px-4 md:px-8 lg:px-16 h-auto xl:h-[50vh]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                {/* Semi-transparent card, fixed width at desktop */}
                <motion.div
                    className="bg-[#3DB73E] bg-opacity-90 rounded-xl py-8 px-6 md:py-12 md:px-10 lg:py-10 lg:px-14 w-full max-w-4xl xl:h-64 xl:max-w-screen-2xl"
                    initial={{ scale: 0.9 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <h1 className="text-2xl md:text-4xl lg:text-5xl font-semibold mb-4 text-center text-white">
                        About Us
                    </h1>
                    <p className="text-base md:text-lg lg:text-xl xl:text-xl leading-relaxed text-center text-white">
                        KrishiYan by WetAcre Sustainable Solutions is a comprehensive, cloud-based
                        agricultural platform designed to revolutionize farming and agribusiness
                        management. Built to support both farmers and FPOs, KrishiYan integrates
                        advanced data analytics, real-time advisory, and streamlined logistics,
                        all accessible through a centralized digital interface. By leveraging cloud
                        technology, KrishiYan offers secure, scalable, and on-demand tools for every
                        stage of the farming cycle, from cultivation to market linkage.
                    </p>
                </motion.div>
            </motion.div>
        </section>
    );
}